<template>
  <action-dispatcher
    action="product/getProduct"
    :parameters="$route.params.id"
    class="view-product-edit-pixel"
  >
    <step-title
      title="Pixel de rastreamento"
      description="Monitore o comportamento dos seus compradores e anúncios."
    />

    <div class="row boxes my-6">
      <div v-for="box in boxes" :key="box.type" class="col-lg-3 box">
        <button class="btn" @click="newPixel(box.type)">
          <img :src="box.img" :alt="box.name" :style="box.style" />
          <span>{{ box.name }}</span>
        </button>
      </div>
    </div>

    <div class="row justify-content-between pt-6">
      <div class="d-flex align-items-center col-lg-6 order-1 order-lg-0">
        <span class="table-quantity-counter mr-5">
          Total: {{ pixelList.length }}
        </span>
        <button class="btn p-0 table-refresh" @click="refresh">
          <i class="fa-solid fa-refresh" />
        </button>
      </div>
      <div class="col-lg-6 d-flex align-items-center">
        <search-filter
          new-design
          class="flex-fill"
          placeholder="Pesquisar"
          :show-results-dropdown="false"
          @search="search"
        />
      </div>
    </div>

    <div class="text-center my-9" v-if="loading">
      <b-spinner variant="primary" />
    </div>

    <div
      v-else-if="!pixelList.length"
      class="container centralize-row text-center pt-9"
    >
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <img
            class="d-block mb-9 mx-auto"
            src="@/assets/images/home/welcome.svg"
          />
          <h5>Você ainda não adicionou um pixel</h5>
          <div class="text-secondary mb-9">
            Clique nos botões acima e adicione o primeiro
          </div>
        </div>
      </div>
    </div>

    <div v-else>
      <data-table
        new-design
        class="d-none d-lg-block"
        :data="pixelList"
        :columns="columns"
      >
        <template #default="{ item, i }">
          <span>
            {{ item.type.toUpperCase() }}
          </span>
          <span>
            {{ item.code }}
          </span>
          <span>
            {{ item.conversion_label || "-" }}
          </span>
          <div class="d-flex align-items-center justify-content-end">
            <actions-dropdown
              :left="false"
              :right="true"
              :actions="actions"
              @edit-pixel="editPixel(item, i)"
              @remove-pixel="submitRemovePixel(i)"
            />
          </div>
        </template>
      </data-table>
      <data-table
        new-design
        class="d-lg-none"
        :data="pixelList"
        :columns="['', '']"
      >
        <template #default="{ item, i }">
          <div class="responsive-table">
            <span>
              <strong>Ferramenta:</strong>
              {{ item.type.toUpperCase() }}
            </span>
            <span>
              <strong>Pixel:</strong>
              {{ item.code }}
            </span>
            <span>
              <strong>Label de Conversão:</strong>
              {{ item.conversion_label || "-" }}
            </span>
          </div>
          <div class="d-flex justify-content-end">
            <actions-dropdown
              :left="false"
              :right="true"
              :actions="actions"
              @edit-pixel="editPixel(item, i)"
              @remove-pixel="submitRemovePixel(i)"
            />
          </div>
        </template>
      </data-table>
    </div>

    <pixel-modal
      v-model="modal"
      :type="pixelType"
      :pixel="editedPixel"
      :custom-conversion-label="pixelType === 'google_ads'"
      @submit="submitPixel"
      @submitEdit="submitEditPixel"
    />
  </action-dispatcher>
</template>

<script>
import PixelModal from "@/components/product/pixel/PixelModal.vue";
import MemberAreaMixin from "@/mixins/memberArea";
import PixelMixin from "@/mixins/pixel";
import ProductActionsMixin from "@/mixins/productActions.js";

export default {
  mixins: [ProductActionsMixin, MemberAreaMixin, PixelMixin],
  components: { PixelModal },
  data() {
    return {
      boxes: [
        {
          name: "Facebook",
          img: require("@/assets/images/fb_icon.svg"),
          type: "facebook"
        },
        {
          name: "Google Ads",
          img: require("@/assets/images/google_ads_icon.svg"),
          type: "google_ads"
        },
        {
          name: "Google Analytics",
          img: require("@/assets/images/google_analytics_icon.svg"),
          type: "google_analytics"
        },
        {
          name: "Kwai",
          img: require("@/assets/images/kwai_icon.png"),
          type: "kwai",
          style: { padding: "10px" }
        }
      ]
    };
  },
  computed: {
    pixelList() {
      if (this.search_text) {
        const res = this.product.pixel.filter(p =>
          JSON.stringify(p)
            .toLowerCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .match(this.search_text)
        );
        return res;
      }
      if (this.product && this.product.pixel) {
        return this.product.pixel;
      }

      return [];
    },
    breadcrumbs() {
      return [
        { title: "Meus produtos", link: "product" },
        {
          title: this.product.name,
          link: "product-details",
          params: { id: this.$route.params.id }
        },
        { title: "Pixel de rastreamento" }
      ];
    }
  },
  mounted() {
    this.getMemberAreaSetup();
  }
};
</script>
<style lang="scss" scoped>
.view-product-edit-pixel {
  .box button {
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;

    padding: 20px 24px;
    border-radius: 8px;
    background: rgba(255, 255, 255, 0.16);
    box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.08);

    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    color: rgba(119, 120, 142, 0.87);

    transition: 0.3s all ease-in-out;

    img {
      width: 84px;
      height: 84px;
      margin-bottom: 10px;
    }

    &:hover {
      box-shadow: 0px 0px 40px 0px rgba(0, 0, 0, 0.08);
      background-color: rgba(255, 255, 255, 0.96);
      border: 1px solid rgba(207, 174, 255, 0.86);
    }
  }
  @media screen and (max-width: 991px) {
    .boxes {
      padding: 12px 0;
      flex-wrap: nowrap;
      overflow-x: scroll;
    }
    .box {
      width: 270px;
      min-width: 270px;
    }
  }
}
</style>
